module.exports = __webpack_public_path__ + "static/media/KD.95d58638.svg";